import {
  PrintWithUsBrandImage,
  SponsorABookBrandImage,
  WriteABrandBookBrandImage,
} from 'assets';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Card, { ICard } from '@/components/Partnership/Common/Card';
import Layout from '@/components/Partnership/Common/Card/Layout';
import Header from '@/components/Partnership/Common/Header';
interface Props {
  className?: string;
}
const ForBrandsSection: FC<Props> = ({ className }) => {
  const list: ICard[] = [
    {
      id: 1,
      title: 'Write a Brand Book',
      button: {
        link: 'https://form.jotform.com/260644797886074',
        text: 'Contact Us →',
      },
      image: WriteABrandBookBrandImage,
      pointers: [
        'Tell your brand story through learning content',
        'Build long-term thought leadership',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
    {
      id: 2,
      title: 'Sponsor a Book',
      button: {
        link: 'https://form.jotform.com/260644797886074',
        text: 'Contact Us →',
      },
      image: SponsorABookBrandImage,
      pointers: [
        'Brand placement in high-engagement books',
        'Reach a focused learning audience',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
    {
      id: 3,
      title: 'Print with us',
      button: {
        link: 'https://form.jotform.com/260644797886074',
        text: 'Contact Us →',
      },
      image: PrintWithUsBrandImage,
      pointers: [
        'High-quality book printing with professional finish',
        'Flexible quantities from small runs to bulk orders',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
  ];
  return (
    <div className={twMerge('', className)}>
      <Header title='For Brands' className='md:pb-4 mb-[18px]' />
      <Layout>
        {list.map((i) => (
          <Card key={i.id} card={i} />
        ))}
      </Layout>
    </div>
  );
};

export default ForBrandsSection;
